import {useContext} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Link, Theme, Typography, useMediaQuery} from '@mui/material';

import {EmpionButton} from '../EmpionButton/EmpionButton';
import EmpionLogo from '../EmpionLogoAnimation/EmpionLogo';

import {LanguageContext} from '../../contexts/LanguageContext/LanguageContext';
import {AppConfig} from '../../lib/AppConfig';

export const NotSignedCompanies = () => {
  const currentLanguage = useContext(LanguageContext);
  const {t} = useTranslation();
  const isXs = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  const bookCallUrl =
    currentLanguage === 'en' ? AppConfig.BOOK_CALL_COMPANIES_URL_EN : AppConfig.BOOK_CALL_COMPANIES_URL_DE;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        textAlign: 'center',
      }}
    >
      <EmpionLogo withAnimation />
      <Typography
        variant={isXs ? 'h3' : 'h2'}
        gutterBottom
        sx={{
          color: 'text.primary',
          mb: 4,
        }}
      >
        {t('notSignedCompanies.title')}
      </Typography>
      <Link href={bookCallUrl} target='_blank' rel='noreferrer' underline='none'>
        <EmpionButton variant='contained'>
          <Typography variant={isXs ? 'h4' : 'h3'}> {t('notSignedCompanies.bookDemo')}</Typography>
        </EmpionButton>
      </Link>
    </Box>
  );
};
